<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_reference_id" class="col-sm-3 mb-0">
						Reference ID
					</label>
					<app-input
						id="inputs_reference_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.email"
						placeholder="Reference ID"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "InvoiceHistoryTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			statusLists: [
				{ id: "", value: "Choose One" },
				{ id: "active", value: "Active" },
				{ id: "inactive", value: "Inactive" },
				{ id: "invited", value: "Invite" },
			],
			subStatusLists: [
				{ id: "", value: "Choose One" },
				{ id: "active", value: "Active" },
				{ id: "inactive", value: "Inactive" },
				{ id: "invited", value: "Invite" },
			],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
